import React, { useState, useRef } from "react"
import SlidingPane from "react-sliding-pane"
import { DropzoneComponent } from "react-dropzone-component"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete"
import { GoogleMap, MarkerF, InfoWindow, Circle, MarkerClusterer } from "@react-google-maps/api"
import { APICALL } from "helper/api/api"
import { currencySign, searchOptions, SOMETHING_ERR } from "helper/Constant"
import { auth, defaultIMG, imgBaseURL, stripeRedirectURI, toastifyError, toastifySuccess } from "helper/Utility"
import TextField from "@mui/material/TextField"
import reyko from '../../assets/images/chat_bot.png'
import { useEffect } from "react"
import InputLabel from "@mui/material/InputLabel"
import Slider from "@mui/material/Slider"
import Select from "@mui/material/Select"
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, MenuItem, OutlinedInput, Radio, RadioGroup, Typography } from "@mui/material"
import { Card, Col, Form, FormLabel, Row } from "react-bootstrap"
import LoginAuth from "./LoginModal"
import BTNLoading from "helper/my-com/BTNLoading"
import { useFrontDataContext } from "helper/context/FrontContextProvider"
import { useNavigate } from "react-router"
import smallSize from "../../assets/img/small.png"
import mediumSize from "../../assets/img/medium.png"
import largeSize from "../../assets/img/large.png"
import xLargeSize from "../../assets/img/x-large.png"
import girlIcon from "../../assets/images/girl-icon.png"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ReactDOM from "react-dom"
import partypost from "../../assets/user-preview.mp4"

import mixandmatch from "../../assets/images/mix-and-match.png"
import localpickup from "../../assets/images/Local-Pickup.png"
import shipping from "../../assets/images/shipping.png"

const previewTemplate = `
  <div class="dz-preview dz-file-preview dz-clickable fx_img nn_selling_img">
    <div class="dz-details">
      <div class="img_cvr nn_stuffimg">
        <img data-dz-thumbnail alt="" />
        <button data-dz-remove>
          <svg viewBox="0 0 24 24">
            <path d="M5.176 6.706a1.176 1.176 0 1 1 0-2.353h4.706a2.353 2.353 0 0 1 4.706 0h4.706a1.176 1.176 0 1 1 0 2.353V20a2 2 0 0 1-2 2H7.176a2 2 0 0 1-2-2V6.706zm4.706 2.353c-.65 0-1.176.421-1.176.941v7.53c0 .52.527.94 1.176.94.65 0 1.177-.42 1.177-.94V10c0-.52-.527-.941-1.177-.941zm4.706 0c-.65 0-1.176.421-1.176.941v7.53c0 .52.526.94 1.176.94.65 0 1.177-.42 1.177-.94V10c0-.52-.527-.941-1.177-.941z"></path>
          </svg>
        </button>
      </div>
      <div class="dz-error-message">
        <span style="color: red" data-dz-errormessage></span>
      </div>
    </div>
  </div>
`

const dictDefaultMessage = `
  <div class="dz-clickable">
    <div class="dropZoneDefault">
      <svg viewBox="0 0 24 24" width="48px" height="48px" fill="#EEEEEE">
        <path d="M19.389 18.3V5.1c0-.221-.194-.4-.425-.4H4.514c-.235 0-.425.176-.425.4v12.786l4.098-5.802c.261-.37.728-.402 1.046-.075l4.233 4.358 1.523-1.438a.836.836 0 0 1 1.175.022l3.225 3.349zm0-15.3c.938 0 1.7.893 1.7 1.995v14.01c0 1.102-.762 1.995-1.7 1.995h-15.3c-.939 0-1.7-.893-1.7-1.995V4.995C2.389 3.893 3.15 3 4.089 3h15.3zm-5.525 7.275a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4z"></path>
      </svg>
      <h1><span>Drag and drop, or browse </span></h1>
      <p><span>Upload up to 10 photos of what you're selling.</span></p>
    </div>
  </div>
`

const dictDefaultMessage1 = `
  <div class="dz-clickable">
    <div class="dropZoneDefault">
      <svg viewBox="0 0 24 24" width="48px" height="48px" fill="#EEEEEE">
        <path d="M19.389 18.3V5.1c0-.221-.194-.4-.425-.4H4.514c-.235 0-.425.176-.425.4v12.786l4.098-5.802c.261-.37.728-.402 1.046-.075l4.233 4.358 1.523-1.438a.836.836 0 0 1 1.175.022l3.225 3.349zm0-15.3c.938 0 1.7.893 1.7 1.995v14.01c0 1.102-.762 1.995-1.7 1.995h-15.3c-.939 0-1.7-.893-1.7-1.995V4.995C2.389 3.893 3.15 3 4.089 3h15.3zm-5.525 7.275a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4z"></path>
      </svg>
      <h1><span>Drag and drop, or browse </span></h1>
      <p><span>Upload 1 video of what you're selling.</span></p>
    </div>
  </div>
`

const MAX = 30
const MIN = 0
const marks = [
    {
        value: MIN,
        label: ""
    },
    {
        value: MAX,
        label: ""
    }
]
const SellYourPartyleftover = ({ isPaneOpen, setIsPaneOpen, product }) => {
    const { contextLoader, getCategoryListFunc, categoryList, userInfo } = useFrontDataContext()
    const mapContainerStyle = {
        width: "100%",
        height: "30vh"
    }
    const defaultCenter = {
        lat: -25.274398,
        lng: 133.775136
    }
    const navigate = useNavigate()
    const [loginModal, setLoginModal] = useState(false)
    const handleCloseLoginModal = () => setLoginModal(false)
    const [searchLatLan, setSearchLatLan] = useState(defaultCenter)
    const [loading, setLoading] = useState(false)
    const [sizeOptions, setSizeOptions] = useState([])
    const [Subcategories, setSubCategories] = useState([])
    const enableDropZone = true
    useEffect(() => {
        getCategoryListFunc("partySupply")
        getSizeOptionsFun()
    }, [])
    const [selectedSize, setSelectedSize] = useState("")

    const [showPreview, setShowPreview] = useState(false)
    const [value, setValue] = useState({
        title: "",
        description: "",
        image: "",
        location: "",
        status: true,
        sellingStatus: "",
        price: "",
        categoryId: "",
        subCategoryId: "",
        userId: null,
        condition: "",
        weight: MAX,
        latitude: "",
        longitude: "",
        video: "",
        deliveryMethod: ""
    })
    const [images, setImages] = useState([])
    const [video, setVideo] = useState(null)
    const [suggestions, setSuggestions] = useState([])
    const [suggestType, setSuggestType] = useState("")
    const [loadingType, setLoadingType] = useState("");
    const [showSection, setShowSection] = useState(false);

    React.useEffect(() => {
        if (product) {
            const videoUrl = product?.video ? `${imgBaseURL()}${product.video}` : "";
            setValue({
                id: product?._id || "",
                title: product?.title || "",
                description: product?.description || "",
                image: product?.gallery?.[0] || "",
                location: product?.location || "",
                status: product?.status ?? true,
                sellingStatus: product?.sellingStatus || "",
                price: product?.price?.toString() || "",
                categoryId: product?.categoryId || "",
                userId: product?.userId || null,
                condition: product?.condition || "",
                deliveryMethod: product?.deliveryMethod || "",
                shippingSizeId: product?.shippingSizeId?._id || "",
                video: videoUrl,
            });
            setImages(
                product?.gallery?.map((img) => `${imgBaseURL()}${img}`) || []
            );
            setVideo(videoUrl || null);
            setShowSection(product?.deliveryMethod !== "partyHandOff");
            setSelectedSize(product?.shippingSizeId?._id || "");
        }
    }, [product]);


    const handleVideoAdd = (file) => {
        if (file.type.startsWith("video/")) {
            setVideo(file)
        }
    }

    const handleVideoRemove = () => {
        setVideo(null)
    }

    const onDragEnd = (result) => {
        if (!result.destination) return

        const reorderedImages = Array.from(images)
        const [movedItem] = reorderedImages.splice(result.source.index, 1)
        reorderedImages.splice(result.destination.index, 0, movedItem)

        setImages(reorderedImages)
    }

    const getSubcategoryByCategory = async (categoryId) => {
        try {
            const res = await APICALL("user/getSubcategoryByCategoryId", "post", { categoryId: categoryId })
            if (res?.status) {
                setSubCategories(res?.data)
            } else {
                setSubCategories([])
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSuggestAi = async (type) => {
        try {
            if (!value.title?.trim()) {
                toastifyError("Title is required!");
                return;
            }
            setLoadingType(type);
            const keyword = value.title;
            const res = await APICALL("admin/generateContent", "post", { keyword: keyword, type: type, });

            if (res?.status) {
                setSuggestions(res.data.suggestions);
                setSuggestType(type);
            } else {
                setSuggestions([]);
                setSuggestType("");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingType("");
        }
    };


    const handleSelectSuggestion = (text) => {
        if (suggestType === "title") {
            setValue({ ...value, title: text });
        } else if (suggestType === "description") {
            setValue({ ...value, description: text });
        }
        setSuggestions([]);
        setSuggestType("");
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target
        setValue((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }))
        if (name == "categoryId") {
            getSubcategoryByCategory(value)
        }
        if (name === "deliveryMethod") {
            if (value === "partyHandOff") {
                setShowSection(false);
                setSelectedSize("");
            } else {
                setShowSection(true);
            }
        }
        // console.log(value, 'value')
        // console.log(name, 'name')
    }

    const [errors, setErrors] = useState({})

    const validate = () => {
        const newErrors = {}
        if (images?.length == 0) newErrors.images = "Please upload images"
        if (!value.categoryId.trim()) newErrors.categoryId = "Please select category"
        // if (!value.subCategoryId.trim()) newErrors.subCategoryId = "Please select sub condition"
        if (!value.title.trim()) newErrors.title = "Please enter title."
        if (!value.price.trim()) newErrors.price = "Please enter rate."
        if (!value.condition.trim()) newErrors.condition = "Please select condition"
        if (!value.deliveryMethod.trim()) newErrors.deliveryMethod = "Please select delivery method"
        if (!value.location.trim()) newErrors.location = "Please enter location"
        // if (!selectedSize.trim()) newErrors.selectedSize = "Please select size"
        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validate()) return
        setShowPreview(true)
        handlePlay()
    }

    const handleConfirmPost = async () => {
        try {
            setLoading(true)
            const weight = { min: 0, max: value.weight }
            const formData = new FormData()
            if (value?.id) {
                formData.append("id", value.id)
            }
            formData.append("type", "partySupply")
            formData.append("title", value.title)
            formData.append("description", value.description)
            formData.append("location", value.location)
            formData.append("status", value.status)
            formData.append("sellingStatus", value.sellingStatus)
            formData.append("categoryId", value.categoryId)
            if (value.subCategoryId) {
                formData.append("subCategoryId", value.subCategoryId)
            }
            formData.append("price", value.price)
            formData.append("weight", JSON.stringify(weight))
            formData.append("userId", auth("user")?.id)
            formData.append("condition", value.condition)
            formData.append("latitude", value.latitude)
            formData.append("longitude", value.longitude)
            formData.append("shippingSizeId", selectedSize)
            formData.append("deliveryMethod", value.deliveryMethod)
            if (video) {
                formData.append("video", video)
            }
            images.forEach((file) => {
                formData.append(`gallery`, file)
            })

            const res = await APICALL("/admin/addOrUpdateProduct", "POST", formData)
            if (res?.status) {
                toastifySuccess(res?.message)
                handleClose()
                navigate(`/profile/${auth("user")?.id}`, { state: "selling" })
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            console.log(error)
            toastifyError(error?.response?.data?.message || "Server Error")
        } finally {
            setLoading(false)
            setShowPreview(false) // close the preview after done
        }
    }

    const handleLocationChange = async (value) => {
        setValue((prevValue) => ({
            ...prevValue,
            location: value
        }))
    }

    const handleLocationSelect = async (value) => {
        try {
            try {
                const results = await geocodeByAddress(value)
                const latLng = await getLatLng(results[0])
                setValue((prevValue) => ({
                    ...prevValue,
                    location: value,
                    latitude: latLng?.lat,
                    longitude: latLng?.lng
                }))
                setSearchLatLan(latLng)
            } catch (error) {
                console.error("Error fetching location details", error)
            }
        } catch (error) {
            console.error("Error selecting address", error)
        }
    }

    const handleClose = () => {
        setValue({
            ...value,
            id: "",
            title: "",
            description: "",
            image: "",
            location: "",
            status: true,
            sellingStatus: "",
            price: "",
            categoryId: "",
            userId: null,
            condition: "",
            deliveryMethod: "",
            weight: 0,
            video: ""
        })
        setIsPaneOpen(false)
        setSearchLatLan(defaultCenter)
        setImages([])
        setVideo(null)
    }

    const videoRef = useRef(null)
    const handlePlay = () => {
        if (videoRef.current) {
            const playPromise = videoRef.current.play()
            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    console.error("Playback error:", error)
                })
            }
        }
    }

    const handlePause = () => {
        if (videoRef.current) {
            videoRef.current.pause()
        }
    }

    const handleChange1 = (event) => {
        setSelectedSize(event.target.value)
        setShowSection(true)
    }

    const getSizeOptionsFun = async () => {
        try {
            const res = await APICALL("admin/getShippingSizes", "post", {})
            if (res?.status) {
                setSizeOptions(res?.data)
            } else {
                setSizeOptions([])
            }
        } catch (error) {
            console.log(error)
        }
    }

    const PortalAwareItem = ({ provided, snapshot, children }) => {
        const child = (
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={{
                    width: "100px",
                    height: "100px",
                    margin: "4px",
                    position: "relative",
                    border: snapshot.isDragging ? "2px dashed #666" : "1px solid #ccc",
                    borderRadius: "8px",
                    background: snapshot.isDragging ? "#f0f0f0" : "#fff",
                    overflow: "hidden",
                    ...provided.draggableProps.style // critical: include this LAST!
                }}
            >
                {children}
            </div>
        )

        return snapshot.isDragging ? ReactDOM.createPortal(child, document.body) : child
    }

    const coneectStripe = async () => {
        if (!validate()) return
        setLoading(true)
        const formData = new FormData()
        if (video) {
            formData.append("video", video)
        }
        images.forEach((file) => {
            formData.append(`gallery`, file)
        })
        const mediaRes = await APICALL("/admin/uploadProductMedia", "POST", formData)
        if (mediaRes?.status === 200) {
            const saveToLocal = {
                ...value,
                type: "partySupply",
                userId: auth("user")?.id,
                shippingSizeId: selectedSize,
                video: mediaRes?.data?.video,
                gallery: mediaRes?.data?.gallery
            }
            const partyData = JSON.stringify(saveToLocal)
            localStorage.setItem("party", partyData)
            try {
                const params = { userEmail: auth("user")?.email, country: "IE", redirectURL: stripeRedirectURI() + auth("user")?.id }
                const res = await APICALL(`user/stripeVarificationLink`, "post", params)
                window.location.href = res.url
            } catch (error) {
                console.error(error)
            } finally {
                setLoading(false)
            }
        } else {
            toastifyError(SOMETHING_ERR)
        }
    }

    const deliveryMethodList = [
        {
            title: "Party Hand-Off",
            desc: "Pickup an order directly from the seller in your area",
            value: "partyHandOff",
            image: shipping
        },
        {
            title: "Party in a Box",
            desc: "Get an order shipped to your door",
            value: "partyInABox",
            image: localpickup
        },
        {
            title: "Mix & Match",
            desc: "Choose pickup or shipping at checkout",
            value: "mixAndMatch",
            image: mixandmatch
        }
    ]

    const selectedSizeOption = sizeOptions.find(item => item?._id === selectedSize) || null;

    return (
        <>
            <div>
                <SlidingPane
                    closeIcon={
                        <div onClick={() => handleClose()} className="slide-pane__close lol">
                            <svg viewBox="0 0 24 24">
                                <path d="M12 9.988l3.822-3.822a1.423 1.423 0 0 1 2.011 2.011L14.012 12l3.821 3.822a1.42 1.42 0 0 1 0 2.011 1.42 1.42 0 0 1-2.011 0L12 14.011l-3.822 3.822a1.42 1.42 0 0 1-2.011 0 1.42 1.42 0 0 1 0-2.01L9.988 12 6.167 8.177a1.42 1.42 0 1 1 2.011-2.01L12 9.987z"></path>
                            </svg>
                        </div>
                    }
                    className="some-custom-class"
                    overlayClassName="some-custom-overlay-class"
                    isOpen={isPaneOpen}
                    title="What are you selling?"
                    onRequestClose={() => handleClose()}
                >
                    <div className="Popup-cartopen">
                        {showPreview && (
                            <div className="preview-modal">
                                <h2 className="preview-title">Preview Your Listing</h2>

                                <div className="preview-gallery-grid">
                                    {images.map((file, idx) => (
                                        <img key={idx} src={typeof file === "string" ? file : URL.createObjectURL(file)} alt={`preview-${idx}`} className="preview-gallery-image" />
                                    ))}
                                    {video && <video key={video} src={typeof video === "string" ? video : URL.createObjectURL(video)} controls className="preview-gallery-video" />}
                                </div>

                                <div className="preview-details">
                                    <h3 className="preview-item-title">
                                        {value.title}
                                    </h3>

                                    <span className="preview-item-price">${value.price}</span>
                                    <p>{value.description}</p>

                                    <div className="preview-location-status">
                                        <div className="icon_loc">
                                            <i class="fa-solid fa-location-dot"></i>
                                        </div>{value.location} | {value.sellingStatus || "New"}
                                    </div>

                                    <div className="preview-location-status">
                                        <div className="icon_loc">
                                            <i class="fa-solid fa-layer-group"></i>
                                        </div> <b> Category :</b>   {value.categoryName}
                                    </div>

                                    <div className="preview-location-status">
                                        <div className="icon_loc">
                                            <i class="fa-solid fa-thumbs-up"></i>
                                        </div><b>Condition : </b>  {value.condition}
                                    </div>

                                    <div className="preview-location-status">
                                        <div className="icon_loc">
                                            <i class="fa-solid fa-truck"></i>
                                        </div><b>Delivery Method : </b>  {value.deliveryMethod}
                                    </div>

                                    {
                                        selectedSizeOption &&
                                        <div className="preview-location-status">
                                            <div className="icon_loc">
                                                <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                                            </div>
                                            <Typography variant="body1">
                                                <strong>{selectedSizeOption?.name}</strong> <br /> (Approx {selectedSizeOption?.length}
                                                {selectedSizeOption?.dimensionUnit === "inch" ? "″" : "cm"} x {selectedSizeOption?.width}
                                                {selectedSizeOption?.dimensionUnit === "inch" ? "″" : "cm"} x {selectedSizeOption?.height}
                                                {selectedSizeOption?.dimensionUnit === "inch" ? "″" : "cm"}, Weight:{" "}
                                                {selectedSizeOption?.weightValue} {selectedSizeOption?.weightUnit})
                                            </Typography>
                                        </div>
                                    }



                                    <div className="preview-condition-box">
                                        {/* <img src={girlIcon} alt="MyPlo Assistant" className="assistant-avatar" /> */}
                                        <video ref={videoRef} src={partypost} width="160" height="160" controls={false} autoPlay={true} style={{ objectFit: "cover" }} />
                                        <div className="assistant-message">Everything look good? Hit Post and let the party begin!</div>
                                    </div>
                                </div>

                                <div className="preview-action-buttons">
                                    <button
                                        className="edit-listing-button"
                                        onClick={() => {
                                            setShowPreview(false)
                                            handlePause()
                                        }}
                                    >
                                        Edit Listing
                                    </button>
                                    {userInfo?.is_connected ? (
                                        <>
                                            {loading ? (
                                                <BTNLoading className={"post-item-button"} />
                                            ) : (
                                                <button className="post-item-button" onClick={handleConfirmPost}>
                                                    Post My Item
                                                </button>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {loading ? (
                                                <BTNLoading className={"post-item-button"} />
                                            ) : (
                                                <button className="post-item-button" onClick={coneectStripe}>
                                                    Post My Item
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}

                        {!showPreview && (
                            <Form className="add-product-form" onSubmit={handleSubmit}>
                                <Row>
                                    {/* Category */}
                                    <Col xs={12} sm={12}>
                                        <FormLabel>
                                            Categories <span style={{ color: "red" }}>* {errors?.categoryId}</span>
                                        </FormLabel>
                                    </Col>

                                    <Col xs={12} sm={12}>
                                        <FormControl className="input_mui_box" fullWidth>
                                            <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                            <Select labelId="demo-simple-select-label" value={value.categoryId} label="Selling Status" name="categoryId"
                                                onChange={(e) => {
                                                    const selectedId = e.target.value;
                                                    const selectedCategory = categoryList.find(item => item._id === selectedId);
                                                    setValue({
                                                        ...value,
                                                        categoryId: selectedId,
                                                        categoryName: selectedCategory?.categoryName || ""
                                                    });
                                                }}
                                            >
                                                {categoryList?.map((item, i) => (
                                                    <MenuItem value={item?._id}>{item?.categoryName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Col>

                                    {/* <Col xs={12} sm={12} className="mt-4">
                                        <FormLabel>
                                            Sub Category <span style={{ color: "red" }}> {errors?.subCategoryId}</span>
                                        </FormLabel>
                                    </Col>

                                    <Col xs={12} sm={12}>
                                        <FormControl className="input_mui_box" fullWidth>
                                            <InputLabel id="demo-simple-select-label">Sub category</InputLabel>
                                            <Select labelId="demo-simple-select-label" value={value.subCategoryId} label="Selling Status" name="subCategoryId" onChange={handleChange}>
                                                {Subcategories?.map((item, i) => (
                                                    <MenuItem value={item?._id}>{item?.categoryName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Col> */}

                                    {/* Image */}
                                    <Col xs={12} sm={12}>
                                        <div className="photosuplod-sell mt-4">
                                            <Col xs={12} sm={12}>
                                                <FormLabel>
                                                    {" "}
                                                    Photos <span style={{ color: "red" }}>* {errors?.images}</span>{" "}
                                                </FormLabel>
                                            </Col>
                                            <Card>
                                                <Card.Body>
                                                    {enableDropZone && (
                                                        <div>
                                                            <div className="outer_upload_my">
                                                                <label className="upload_label_my" htmlFor="upload">
                                                                    <svg viewBox="0 0 24 24" width="48px" height="48px" fill="#EEEEEE">
                                                                        <path d="M19.389 18.3V5.1c0-.221-.194-.4-.425-.4H4.514c-.235 0-.425.176-.425.4v12.786l4.098-5.802c.261-.37.728-.402 1.046-.075l4.233 4.358 1.523-1.438a.836.836 0 0 1 1.175.022l3.225 3.349zm0-15.3c.938 0 1.7.893 1.7 1.995v14.01c0 1.102-.762 1.995-1.7 1.995h-15.3c-.939 0-1.7-.893-1.7-1.995V4.995C2.389 3.893 3.15 3 4.089 3h15.3zm-5.525 7.275a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4z"></path>
                                                                    </svg>

                                                                    <p>Drag and drop, or browse </p>
                                                                    <span>Upload Photos of what you're selling.</span>
                                                                </label>
                                                                <input
                                                                    className="d-none"
                                                                    id="upload"
                                                                    type="file"
                                                                    accept="image/png, image/jpeg, image/jpg"
                                                                    multiple
                                                                    onChange={(e) => {
                                                                        const files = Array.from(e.target.files)
                                                                        auth("user") ? setImages((prev) => [...prev, ...files]) : setLoginModal(true)
                                                                    }}
                                                                />

                                                                <DragDropContext onDragEnd={onDragEnd} enableDefaultDragHandles={true}>
                                                                    <Droppable droppableId="images-droppable" direction="horizontal">
                                                                        {(provided) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.droppableProps}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    flexWrap: "wrap",
                                                                                    gap: "10px",
                                                                                    marginTop: "10px",
                                                                                    minHeight: "110px" // ensure space is always reserved!
                                                                                }}
                                                                            >
                                                                                {images.map((file, idx) => (
                                                                                    <Draggable key={`${file.name}-${idx}`} draggableId={`${file.name}-${idx}`} index={idx}>
                                                                                        {(provided, snapshot) => (
                                                                                            <PortalAwareItem provided={provided} snapshot={snapshot}>
                                                                                                <img
                                                                                                    src={typeof file === "string" ? file : URL.createObjectURL(file)}
                                                                                                    alt={`preview-${idx}`}
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                        height: "100%",
                                                                                                        objectFit: "cover",
                                                                                                        borderRadius: "8px"
                                                                                                    }}
                                                                                                />
                                                                                                <button
                                                                                                    onClick={() => setImages((prev) => prev.filter((_, i) => i !== idx))}
                                                                                                    style={{
                                                                                                        position: "absolute",
                                                                                                        top: "4px",
                                                                                                        right: "4px",
                                                                                                        background: "red",
                                                                                                        color: "white",
                                                                                                        border: "none",
                                                                                                        borderRadius: "50%",
                                                                                                        width: "20px",
                                                                                                        height: "20px",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                        justifyContent: "center",
                                                                                                        cursor: "pointer"
                                                                                                    }}
                                                                                                >
                                                                                                    ×
                                                                                                </button>
                                                                                            </PortalAwareItem>
                                                                                        )}
                                                                                    </Draggable>
                                                                                ))}
                                                                                {provided.placeholder}
                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                </DragDropContext>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Col>

                                    {/* Video */}
                                    <Col xs={12} sm={12}>
                                        <div className="photosuplod-sell mt-4">
                                            <Col xs={12} sm={12}>
                                                <FormLabel> Video</FormLabel>
                                            </Col>
                                            <Card>
                                                <Card.Body>
                                                    <DropzoneComponent
                                                        id="item-video"
                                                        config={{
                                                            postUrl: "no-url",
                                                            iconFiletypes: [".mp4", "video/*"],
                                                            showFiletypeIcon: true
                                                        }}
                                                        eventHandlers={{
                                                            addedfile: (file) => {
                                                                if (video) {
                                                                    handleVideoRemove() // remove existing file from state
                                                                    const dropzone = window.Dropzone.forElement("#item-video")
                                                                    dropzone.removeAllFiles() // clear Dropzone UI
                                                                }
                                                                handleVideoAdd(file)
                                                            },
                                                            removedfile: handleVideoRemove
                                                        }}
                                                        djsConfig={{
                                                            acceptedFiles: ".mp4",
                                                            autoProcessQueue: false,
                                                            clickable: true,
                                                            thumbnailWidth: 400,
                                                            thumbnailHeight: 400,
                                                            maxFiles: 1, // <--- this limits Dropzone to 1 file
                                                            previewTemplate,
                                                            dictDefaultMessage: dictDefaultMessage1
                                                        }}
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Col>

                                    {/* {auth("user") && (!userInfo?.is_connected || !userInfo?.status) && (
                                        <Col xs={12} sm={12} className="mt-4">
                                            {!userInfo?.status && !userInfo?.is_connected ? (
                                                <>
                                                    <p className="text-danger text-danger d-flex gap-1">
                                                        <i class="fa-solid fa-circle-exclamation fa-beat-fade mt-1"></i> Please complete your profile verification and connect Stripe account to add products.
                                                    </p>
                                                    <div className="text-end">
                                                        <button type="button" className="see_all-all border-0 bg-transparent" onClick={() => handleRedirect()}>
                                                            Complete Profile <i class="fa-solid fa-arrow-right"></i>
                                                        </button>
                                                    </div>
                                                </>
                                            ) : !userInfo?.status ? (
                                                <>
                                                    <p className="text-danger text-danger d-flex gap-1">
                                                        <i class="fa-solid fa-circle-exclamation fa-beat-fade mt-1"></i> Profile verification pending. Please complete your profile to add products.
                                                    </p>
                                                    <div className="text-end">
                                                        <button type="button" className="see_all-all border-0 bg-transparent" onClick={() => handleRedirect()}>
                                                            Verify Profile <i class="fa-solid fa-arrow-right"></i>
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="text-danger text-danger d-flex gap-1">
                                                        <i class="fa-solid fa-circle-exclamation fa-beat-fade mt-1"></i> Stripe account is not connected. Please connect to start selling products.
                                                    </p>
                                                    <div className="text-end">
                                                        <button type="button" className="see_all-all border-0 bg-transparent" onClick={() => handleRedirect()}>
                                                            Connect Stripe <i class="fa-solid fa-arrow-right"></i>
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </Col>
                                    )} */}

                                    {/* {value?.categoryId && images?.length > 0 && userInfo?.is_connected && userInfo?.status && ( */}
                                    <>
                                        <Col xs={12} sm={12} className="mt-2">
                                            <FormLabel>
                                                Location <span style={{ color: "red" }}>* {errors?.location}</span>
                                            </FormLabel>
                                        </Col>
                                        <Col xs={12} sm={12}>
                                            <div className="location_relate">
                                                <div>
                                                    <PlacesAutocomplete value={value?.location} name="street" onChange={handleLocationChange} onSelect={handleLocationSelect} searchOptions={searchOptions}>
                                                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                            <div className="location_input hover_my mb-0">
                                                                <input className="location-cutome-input mb-0" {...getInputProps({ placeholder: "Location" })} />
                                                                <div className="autocomplete-dropdown-container">
                                                                    {loading ? <div>Loading...</div> : null}
                                                                    {suggestions?.map((suggestion) => {
                                                                        const style = {
                                                                            backgroundColor: suggestion.active ? "whitesmoke" : "#fff",
                                                                            padding: "10px 10px",
                                                                            cursor: "pointer"
                                                                        }
                                                                        return (
                                                                            <div {...getSuggestionItemProps(suggestion, { style })} key={suggestion.placeId}>
                                                                                {suggestion.description}
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </PlacesAutocomplete>
                                                </div>

                                                <div className="car-mpas-add">
                                                    <GoogleMap
                                                        mapContainerStyle={mapContainerStyle}
                                                        zoom={6.9}
                                                        center={searchLatLan}
                                                        options={{
                                                            disableDefaultUI: true,
                                                            mapTypeControl: false,
                                                            zoomControl: true,
                                                            fullscreenControl: false
                                                        }}
                                                    >
                                                        <MarkerF position={searchLatLan} />
                                                    </GoogleMap>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* condition */}
                                        <Col xs={12} sm={12} className="mt-2">
                                            <FormLabel>
                                                Condition <span style={{ color: "red" }}>* {errors?.condition}</span>
                                            </FormLabel>
                                        </Col>
                                        <Col xs={12} sm={12} className=" mb-3">
                                            <FormControl variant="standard" sx={{ minWidth: 120 }} fullWidth>
                                                <InputLabel id="demo-simple-select-standard-label">Condition</InputLabel>
                                                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={value.condition} onChange={handleChange} label="Condition" name="condition">
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    <MenuItem value="Excellent">Excellent</MenuItem>
                                                    <MenuItem value="Good">Good</MenuItem>
                                                    <MenuItem value="Fair">Fair</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>

                                        {/* Title */}
                                        <Col xs={12} sm={12} className="mt-3 ">
                                            <FormLabel>
                                                Title <span style={{ color: "red" }}>* {errors?.title}</span>
                                            </FormLabel>
                                        </Col>

                                        <Col xs={12} sm={12} className="mb-3 d-flex flex-column">
                                            <div className="outer_ai d-flex align-items-start">
                                                <TextField placeholder="Title" value={value.title} onChange={handleChange} name="title" variant="standard"
                                                    className="w-100 me-2"
                                                // inputProps={{ maxLength: 70 }}
                                                />

                                                {loadingType === "title" ? (
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                ) : (
                                                    <div className="outer_aii">

                                                        <button
                                                            className="button-container ms-2"
                                                            onClick={() => handleSuggestAi("title")}
                                                        >
                                                            <span className="sparkle-bg"></span>
                                                            <div className="content">
                                                                <span className="ai-text">
                                                                    <img src={reyko} alt="" />
                                                                </span>
                                                            </div>

                                                            {/* Tooltip message */}

                                                        </button>
                                                        <span className="ai-tooltip">       Click my icon and I’ll create a better title to help your listing shine</span>
                                                    </div>
                                                )}
                                            </div>

                                            {suggestions.length > 0 && suggestType === "title" && (
                                                <ul className="showing list-group mt-2">
                                                    {suggestions.map((suggestion, index) => (
                                                        <li key={index} className="list-group-item" onClick={() => handleSelectSuggestion(suggestion)} style={{ cursor: "pointer" }}>
                                                            {suggestion}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </Col>

                                        <Col xs={12} sm={12} className="mt-3  ">
                                            <FormLabel>Description</FormLabel>
                                        </Col>

                                        <Col xs={12} sm={12} className="d-flex flex-column">
                                            <div className="outer_ai d-flex align-items-start">
                                                <TextField className="w-100 me-2" onChange={handleChange} name="description" multiline rows={1} id="description" value={value.description}
                                                    variant="standard"
                                                //  inputProps={{ maxLength: 50 }} 
                                                />

                                                {loadingType === "description" ? (
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                ) : (
                                                    <div className="outer_aii">
                                                        <button
                                                            className="button-container ms-2"
                                                            onClick={() => handleSuggestAi("description")}
                                                        >
                                                            <span className="sparkle-bg"></span>
                                                            <div className="content">

                                                                <span className="ai-text">
                                                                    <img src={reyko} alt="" />
                                                                </span>
                                                            </div>

                                                            {/* Tooltip message */}

                                                        </button>

                                                        <span className="ai-tooltip description"> Click my icon and I’ll write a description that sells — save time and post faster</span>

                                                    </div>
                                                )}
                                            </div>

                                            {suggestions.length > 0 && suggestType === "description" && (
                                                <ul className="showing list-group mt-2">
                                                    {suggestions.map((suggestion, index) => (
                                                        <li key={index} className="list-group-item" onClick={() => handleSelectSuggestion(suggestion)} style={{ cursor: "pointer" }}>
                                                            {suggestion}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </Col>

                                        {/* Price */}
                                        <Col xs={12} sm={12} className="mt-3 ">
                                            <FormLabel>
                                                ({currencySign})Price<span style={{ color: "red" }}>* {errors?.price}</span>
                                            </FormLabel>
                                        </Col>

                                        <Col xs={12} sm={12} className="">
                                            <TextField
                                                placeholder="Price"
                                                value={value.price}
                                                onChange={(e) => {
                                                    const numericValue = e.target.value.replace(/[^0-9.]/g, "")
                                                    handleChange({
                                                        target: {
                                                            name: "price",
                                                            value: numericValue
                                                        }
                                                    })
                                                }}
                                                name="price"
                                                variant="standard"
                                                className="w-100 mb-3"
                                                inputProps={{ maxLength: 6 }}
                                            />
                                        </Col>

                                        <Col xs={12} sm={12} className="mt-3">
                                            <FormLabel>
                                                Delivery Method <span style={{ color: "red" }}>* {errors?.deliveryMethod}</span>
                                            </FormLabel>
                                            <FormControl component="fieldset" className="w-100">
                                                <RadioGroup value={value?.deliveryMethod} name="deliveryMethod" onChange={handleChange} className="shippingbox-details_outer">
                                                    {deliveryMethodList.map((row, i) => (
                                                        <Box key={i} className="shippingbox-details">
                                                            <FormControlLabel
                                                                value={row.value}
                                                                control={<Radio color="primary" />}
                                                                label={
                                                                    <Typography variant="body1">
                                                                        <strong>{row?.title}</strong> <br />
                                                                        {row?.desc}
                                                                    </Typography>
                                                                }
                                                            />
                                                            <img src={row?.image ? row?.image : defaultIMG} alt={row.value} width="80" height="80" />
                                                        </Box>
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </Col>

                                        {showSection && (
                                            <Col xs={12} sm={12} className="mt-3">
                                                <FormLabel>
                                                    Select Shipping Size & Weight{" "}
                                                    <span style={{ color: "red" }}>* {errors?.selectedSize}</span>
                                                </FormLabel>
                                                <FormControl component="fieldset" className="w-100">
                                                    <RadioGroup
                                                        value={selectedSize}
                                                        onChange={handleChange1}
                                                        className="shippingbox-details_outer"
                                                    >
                                                        {sizeOptions.map((row) => (
                                                            <Box key={row._id} className="shippingbox-details">
                                                                <FormControlLabel
                                                                    value={row._id}
                                                                    control={<Radio color="primary" />}
                                                                    label={
                                                                        <Typography variant="body1">
                                                                            <strong>{row?.name}</strong> <br /> (Approx {row?.length}
                                                                            {row?.dimensionUnit === "inch" ? "″" : "cm"} x {row?.width}
                                                                            {row?.dimensionUnit === "inch" ? "″" : "cm"} x {row?.height}
                                                                            {row?.dimensionUnit === "inch" ? "″" : "cm"}, Weight:{" "}
                                                                            {row?.weightValue} {row?.weightUnit})
                                                                        </Typography>
                                                                    }
                                                                />
                                                                <img
                                                                    src={row?.image ? imgBaseURL() + row?.image : defaultIMG}
                                                                    alt={row.value}
                                                                    width="80"
                                                                    height="80"
                                                                />
                                                            </Box>
                                                        ))}
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col>
                                        )}

                                    </>
                                    {/* )} */}
                                </Row>
                                {!auth("user") ? (
                                    <button className="filter_btn-modal" type="button" onClick={() => setLoginModal(true)}>
                                        Done
                                    </button>
                                ) : !userInfo?.is_connected ? (
                                    <div className="footer-filterbtn">
                                        {loading ? (
                                            <BTNLoading className={"filter_btn-modal"} />
                                        ) : (
                                            <button
                                                className="filter_btn-modal"
                                                type="button"
                                                onClick={() => {
                                                    setShowPreview(true)
                                                    togglePlayPause()
                                                }}
                                            >
                                                Done
                                            </button>
                                        )}
                                    </div>
                                ) : !userInfo?.status ? (
                                    <div className="footer-filterbtn">
                                        {loading ? (
                                            <BTNLoading className={"filter_btn-modal"} />
                                        ) : (
                                            <button className="filter_btn-modal" type="button" onClick={() => navigate("/profile")}>
                                                Done
                                            </button>
                                        )}
                                    </div>
                                ) : (
                                    <div className="footer-filterbtn">
                                        {loading ? (
                                            <BTNLoading className={"filter_btn-modal"} />
                                        ) : (
                                            <button className="filter_btn-modal" type="submit">
                                                Done
                                            </button>
                                        )}
                                    </div>
                                )}
                            </Form>
                        )}
                    </div>
                </SlidingPane>
                <LoginAuth show={loginModal} handleClose={handleCloseLoginModal} />
            </div>
        </>
    )
}

export default SellYourPartyleftover
